import FormRoomGoods from './FormRoomGoods';

export default FormRoomGoods;
